// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4n-6";
export var headerCell = "_4n-2";
export var rowWrapper = "_4n-4";
export var stickyAggregationCell = "_4n-a";
export var stickyAggregationRow = "_4n-7";
export var stickyColumnCell = "_4n-9";
export var stickyColumnHeaderCell = "_4n-8";
export var table = "_4n-1";
export var virtualRowWrapper = "_4n-5";
export var virtualTableContainer = "_4n-0";
export var white = "_4n-3";